import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, unref as _unref, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "space-y-4"
};
const _hoisted_2 = {
  class: "flex flex-wrap items-start justify-between gap-2"
};
const _hoisted_3 = {
  class: "text-base font-semibold text-slate-900"
};
const _hoisted_4 = {
  class: "mt-1 text-sm text-slate-500"
};
const _hoisted_5 = {
  key: 0,
  class: "status-badge is-neutral"
};
const _hoisted_6 = {
  key: 0,
  class: "rounded-lg border border-slate-200 bg-white px-3 py-2 shadow-sm"
};
const _hoisted_7 = {
  class: "flex flex-wrap items-center gap-1.5"
};
const _hoisted_8 = ["disabled", "onClick"];
const _hoisted_9 = {
  key: 0,
  class: "rounded bg-slate-100 px-1.5 py-0.5 text-[0.65rem] font-medium text-slate-500"
};
const _hoisted_10 = {
  key: 1,
  class: "text-[0.65rem] text-slate-400"
};
const _hoisted_11 = {
  key: 0,
  class: "text-xs text-slate-400"
};
const _hoisted_12 = {
  key: 0,
  class: "mt-2 rounded-md bg-slate-50 px-2.5 py-1.5"
};
const _hoisted_13 = {
  class: "flex flex-wrap items-center justify-between gap-1.5"
};
const _hoisted_14 = {
  class: "flex flex-wrap items-center gap-1.5"
};
const _hoisted_15 = {
  class: "status-badge is-neutral"
};
const _hoisted_16 = {
  key: 0,
  class: "status-badge is-warning"
};
const _hoisted_17 = {
  class: "text-xs text-slate-400"
};
const _hoisted_18 = {
  key: 0,
  class: "mt-1 break-words text-xs leading-5 text-slate-500"
};
const _hoisted_19 = {
  key: 0
};
const _hoisted_20 = {
  key: 1,
  class: "data-table-empty is-compact"
};
const _hoisted_21 = {
  key: 0,
  class: "data-table-empty is-compact"
};
const _hoisted_22 = {
  key: 1,
  class: "grid gap-2 md:grid-cols-2"
};
const _hoisted_23 = {
  class: "border-t border-slate-200 pt-4"
};
const _hoisted_24 = {
  class: "mb-2"
};
const _hoisted_25 = {
  class: "text-sm font-semibold text-slate-800"
};
const _hoisted_26 = {
  class: "mt-1 text-xs leading-5 text-slate-500"
};
const _hoisted_27 = {
  class: "grid gap-2 md:grid-cols-2"
};
const _hoisted_28 = {
  class: "text-xs font-medium text-slate-500"
};
const _hoisted_29 = {
  class: "mt-1 whitespace-pre-wrap break-words text-sm leading-6 text-slate-800"
};
const _hoisted_30 = {
  class: "sr-only"
};
import { computed } from 'vue';
import ReportWorkItemEditor from './ReportWorkItemEditor.vue';
import { formatReportDisplayDateTime, workReportPhaseLabel } from '../workReportUtils';
export default {
  __name: 'ReportComparisonPanel',
  props: {
    report: {
      type: Object,
      default: null
    },
    workItems: {
      type: Array,
      default: () => []
    },
    versions: {
      type: Array,
      default: () => []
    },
    selectedVersion: {
      type: Object,
      default: null
    },
    loadingVersion: {
      type: Boolean,
      default: false
    }
  },
  emits: ['select-version', 'open-annotations'],
  setup(__props, {
    emit: __emit
  }) {
    const SUBMITTED_PHASE_STATUSES = new Set(['SUBMITTED', 'PENDING_SUPPLEMENT', 'LATE']);
    const VERSION_ACTION_LABELS = {
      SUBMIT: '提交',
      ADJUST: '调整',
      SUPPLEMENT: '补充'
    };
    const props = __props;
    const emit = __emit;
    const selectedVersionPayload = computed(() => props.selectedVersion || null);
    const displayReport = computed(() => props.selectedVersion || props.report);
    const items = computed(() => {
      if (Array.isArray(displayReport.value?.workItems)) return displayReport.value.workItems;
      return Array.isArray(props.workItems) ? props.workItems : [];
    });
    const planStatus = computed(() => displayReport.value?.statusSummary?.planStatus || displayReport.value?.planStatus);
    const summaryStatus = computed(() => displayReport.value?.statusSummary?.summaryStatus || displayReport.value?.summaryStatus);
    const hasSubmittedSummary = computed(() => isSubmittedPhase(summaryStatus.value, displayReport.value?.summarySubmittedAt));
    const hasSubmittedPlan = computed(() => isSubmittedPhase(planStatus.value, displayReport.value?.planSubmittedAt));
    const displayPhase = computed(() => {
      const selectedPhase = versionPhase(selectedVersionPayload.value?.phase);
      if (selectedPhase) return selectedPhase;
      if (hasSubmittedSummary.value) return 'summary';
      if (hasSubmittedPlan.value) return 'plan';
      if (!displayReport.value && items.value.length) return 'summary';
      return 'none';
    });
    const versionOptions = computed(() => {
      const versions = Array.isArray(props.versions) ? props.versions : [];
      const selectedKey = selectedVersionPayload.value ? versionKey(selectedVersionPayload.value) : '';
      return versions.map(version => {
        const key = versionKey(version);
        const current = currentPhaseVersion(version.phase) === normalizeVersionNo(version.versionNo);
        return {
          raw: version,
          key,
          label: `${workReportPhaseLabel(version.phase)} v${valueOf(version.versionNo)}`,
          current,
          selected: selectedKey ? key === selectedKey : current && versionPhase(version.phase) === displayPhase.value,
          attachments: Array.isArray(version.attachments) ? version.attachments : []
        };
      });
    });
    const activeVersion = computed(() => {
      if (selectedVersionPayload.value) return selectedVersionPayload.value;
      return versionOptions.value.find(version => version.selected)?.raw || null;
    });
    const activeVersionLabel = computed(() => {
      if (!activeVersion.value) return '';
      return `${workReportPhaseLabel(activeVersion.value.phase)} v${valueOf(activeVersion.value.versionNo)}`;
    });
    const contentTitle = computed(() => {
      if (displayPhase.value === 'summary') return '总结内容';
      if (displayPhase.value === 'plan') return '计划内容';
      return '暂无日报内容';
    });
    const contentDescription = computed(() => {
      if (selectedVersionPayload.value && displayPhase.value === 'summary') return '当前展示所选总结版本快照。';
      if (selectedVersionPayload.value && displayPhase.value === 'plan') return '当前展示所选计划版本快照。';
      if (displayPhase.value === 'summary') return '总结已提交，当前展示计划目标与执行结果。';
      if (displayPhase.value === 'plan') return '总结未提交，当前展示已提交计划。';
      return '计划和总结均未提交，暂无可查看内容。';
    });
    const emptyWorkItemText = computed(() => displayPhase.value === 'summary' ? '暂无工作项，可查看总结概要。' : '暂无工作项');
    const planFields = computed(() => [{
      key: 'planFocus',
      label: '今日重点',
      value: displayReport.value?.planFocus
    }, {
      key: 'planCollaborationNeed',
      label: '需要协同',
      value: displayReport.value?.planCollaborationNeed
    }, {
      key: 'planSupplement',
      label: '补充说明',
      value: displayReport.value?.planSupplement,
      class: 'md:col-span-2'
    }]);
    const summaryFields = computed(() => [{
      key: 'summaryAchievement',
      label: '今日成果',
      value: displayReport.value?.summaryAchievement,
      class: 'md:col-span-2'
    }, {
      key: 'summaryBlocker',
      label: '阻塞事项',
      value: displayReport.value?.summaryBlocker
    }, {
      key: 'summaryAssistanceNeeded',
      label: '需要协助',
      value: displayReport.value?.summaryAssistanceNeeded
    }, {
      key: 'summarySupplement',
      label: '补充说明',
      value: displayReport.value?.summarySupplement,
      class: 'md:col-span-2'
    }]);
    const activeFields = computed(() => displayPhase.value === 'summary' ? summaryFields.value : planFields.value);
    const overviewTitle = computed(() => displayPhase.value === 'summary' ? '总结概要' : '计划概要');
    const overviewDescription = computed(() => displayPhase.value === 'summary' ? '展示该日报的总结正文，不在团队工作台内编辑。' : '展示该日报的计划正文，不在团队工作台内编辑。');
    const snapshotCount = computed(() => items.value.filter(item => item?.todoSnapshot || item?.currentTodoSnapshot).length);
    function isSubmittedPhase(status, submittedAt) {
      if (submittedAt) return true;
      return SUBMITTED_PHASE_STATUSES.has(status);
    }
    function versionPhase(phase) {
      const normalized = String(phase || '').toUpperCase();
      if (normalized === 'SUMMARY') return 'summary';
      if (normalized === 'PLAN') return 'plan';
      return '';
    }
    function versionKey(version) {
      return `${String(version?.phase || '').toUpperCase()}-${normalizeVersionNo(version?.versionNo)}`;
    }
    function currentPhaseVersion(phase) {
      const normalized = versionPhase(phase);
      const value = normalized === 'summary' ? props.report?.summaryVersion : props.report?.planVersion;
      return normalizeVersionNo(value);
    }
    function normalizeVersionNo(value) {
      if (value === undefined || value === null || value === '') return '';
      return String(value);
    }
    function versionActionLabel(action) {
      const normalized = String(action || '').toUpperCase();
      return VERSION_ACTION_LABELS[normalized] || '版本变更';
    }
    function valueOf(value) {
      if (value === undefined || value === null || value === '') return '--';
      if (Array.isArray(value)) return value.length ? value.join('、') : '--';
      if (typeof value === 'object') return JSON.stringify(value);
      return value;
    }
    function workItemAnnotationCount(item) {
      const count = Number(item?.todoAnnotationCount ?? item?.currentTodoSnapshot?.annotationCount ?? item?.todoSnapshot?.annotationCount);
      return Number.isFinite(count) ? count : 0;
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, [_createElementVNode("h3", _hoisted_3, _toDisplayString(contentTitle.value), 1), _createElementVNode("p", _hoisted_4, _toDisplayString(contentDescription.value), 1)]), displayPhase.value !== 'none' ? (_openBlock(), _createElementBlock("span", _hoisted_5, " 当前展示：" + _toDisplayString(displayPhase.value === 'summary' ? '总结' : '计划'), 1)) : _createCommentVNode("", true)]), versionOptions.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_cache[0] || (_cache[0] = _createElementVNode("span", {
        class: "text-xs font-medium text-slate-500"
      }, "版本", -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(versionOptions.value, version => {
        return _openBlock(), _createElementBlock("button", {
          key: version.key,
          type: "button",
          class: _normalizeClass(["inline-flex cursor-pointer items-center gap-1 rounded-md border px-2 py-1 text-xs font-medium transition-colors duration-200 disabled:cursor-not-allowed disabled:opacity-60", version.selected ? 'border-blue-500 bg-blue-50 text-blue-700' : 'border-slate-200 bg-white text-slate-600 hover:border-blue-200 hover:bg-blue-50/60 hover:text-blue-700']),
          disabled: __props.loadingVersion,
          onClick: $event => emit('select-version', version.raw)
        }, [_createElementVNode("span", null, _toDisplayString(version.label), 1), version.current ? (_openBlock(), _createElementBlock("span", _hoisted_9, "当前")) : _createCommentVNode("", true), version.attachments?.length ? (_openBlock(), _createElementBlock("span", _hoisted_10, "附件 " + _toDisplayString(version.attachments.length), 1)) : _createCommentVNode("", true)], 10, _hoisted_8);
      }), 128)), __props.loadingVersion ? (_openBlock(), _createElementBlock("span", _hoisted_11, "加载中...")) : _createCommentVNode("", true)]), activeVersion.value ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("span", _hoisted_15, _toDisplayString(activeVersionLabel.value), 1), activeVersion.value.lateAdjustment ? (_openBlock(), _createElementBlock("span", _hoisted_16, "迟交后调整")) : _createCommentVNode("", true)]), _createElementVNode("time", _hoisted_17, _toDisplayString(_unref(formatReportDisplayDateTime)(activeVersion.value.occurredAt)), 1)]), activeVersion.value.action || activeVersion.value.reason ? (_openBlock(), _createElementBlock("p", _hoisted_18, [_createTextVNode(_toDisplayString(versionActionLabel(activeVersion.value.action)), 1), activeVersion.value.reason ? (_openBlock(), _createElementBlock("span", _hoisted_19, "：" + _toDisplayString(activeVersion.value.reason), 1)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), displayPhase.value === 'none' ? (_openBlock(), _createElementBlock("div", _hoisted_20, "该员工尚未提交今日计划或总结。")) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 2
      }, [items.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(emptyWorkItemText.value), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_22, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, index) => {
        return _openBlock(), _createBlock(ReportWorkItemEditor, {
          key: item.id || item.clientKey || index,
          item: item,
          phase: displayPhase.value,
          readonly: true,
          "annotation-count": workItemAnnotationCount(item),
          onOpenAnnotations: $event => emit('open-annotations', item)
        }, null, 8, ["item", "phase", "annotation-count", "onOpenAnnotations"]);
      }), 128))])), _createElementVNode("section", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createElementVNode("h3", _hoisted_25, _toDisplayString(overviewTitle.value), 1), _createElementVNode("p", _hoisted_26, _toDisplayString(overviewDescription.value), 1)]), _createElementVNode("dl", _hoisted_27, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeFields.value, field => {
        return _openBlock(), _createElementBlock("div", {
          key: field.key,
          class: _normalizeClass(["min-w-0 rounded-lg border border-slate-200 bg-white px-3 py-2 shadow-sm", field.class])
        }, [_createElementVNode("dt", _hoisted_28, _toDisplayString(field.label), 1), _createElementVNode("dd", _hoisted_29, _toDisplayString(valueOf(field.value)), 1)], 2);
      }), 128))])])], 64)), _createElementVNode("p", _hoisted_30, "待办快照 " + _toDisplayString(snapshotCount.value) + " " + _toDisplayString(items.value.some(item => item?.currentTodoSnapshot) ? 'currentTodoSnapshot' : ''), 1)]);
    };
  }
};